module.exports = __webpack_public_path__ + "img/arrow-up-from-square.4330e97f.svg";